// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoCircleOutlinedSvg from "@fishx/icons-svg/es/asn/TaobaoCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var TaobaoCircleOutlined = function TaobaoCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleOutlinedSvg
  }));
};

TaobaoCircleOutlined.displayName = 'TaobaoCircleOutlined';
export default React.forwardRef(TaobaoCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TaobaoCircleOutlined.js
// module id = 4250
// module chunks = 0